import axios from '../../../../utills/axiosConfig';

export const fetchStoneSizes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/stone-sizes', { params });
  return res.data;
};

export const addStoneSize = async (stoneSize) => {
  try {
    const res = await axios.post('/stone-sizes', stoneSize);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateStoneSize = async (id, stoneSize) => {
  console.log('API call - Updating stone size:', id, stoneSize);
  const res = await axios.put(`/stone-sizes/${id}`, stoneSize);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteStoneSize = async (id) => {
  const res = await axios.delete(`/stone-sizes/${id}`);
  return res.data;
};

export const importStoneSizeCSV = async (formData) => {
  const { data } = await axios.post('/stone-sizes/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 